'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../languageHandler');

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _Field = require('../elements/Field');

var _Field2 = _interopRequireDefault(_Field);

var _AccessibleButton = require('../elements/AccessibleButton');

var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Merge with ProfileSettings?
var RoomProfileSettings = function (_React$Component) {
    (0, _inherits3.default)(RoomProfileSettings, _React$Component);

    function RoomProfileSettings(props) {
        (0, _classCallCheck3.default)(this, RoomProfileSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RoomProfileSettings.__proto__ || (0, _getPrototypeOf2.default)(RoomProfileSettings)).call(this, props));

        _initialiseProps.call(_this);

        var client = _MatrixClientPeg2.default.get();
        var room = client.getRoom(props.roomId);
        if (!room) throw new Error("Expected a room for ID: ", props.roomId);
        var avatarEvent = room.currentState.getStateEvents("m.room.avatar", "");
        var avatarUrl = avatarEvent && avatarEvent.getContent() ? avatarEvent.getContent()["url"] : null;
        if (avatarUrl) avatarUrl = client.mxcUrlToHttp(avatarUrl, 96, 96, 'crop', false);
        var topicEvent = room.currentState.getStateEvents("m.room.topic", "");
        var topic = topicEvent && topicEvent.getContent() ? topicEvent.getContent()['topic'] : '';
        _this.state = {
            originalDisplayName: room.name,
            displayName: room.name,
            originalAvatarUrl: avatarUrl,
            avatarUrl: avatarUrl,
            avatarFile: null,
            originalTopic: topic,
            topic: topic,
            enableProfileSave: false,
            canSetName: room.currentState.maySendStateEvent('m.room.name', client.getUserId()),
            canSetTopic: room.currentState.maySendStateEvent('m.room.topic', client.getUserId()),
            canSetAvatar: room.currentState.maySendStateEvent('m.room.avatar', client.getUserId())
        };
        return _this;
    }

    (0, _createClass3.default)(RoomProfileSettings, [{
        key: 'render',
        value: function render() {
            // TODO: Why is rendering a box with an overlay so complicated? Can the DOM be reduced?

            var showOverlayAnyways = true;
            var avatarElement = _react2.default.createElement('div', { className: 'mx_ProfileSettings_avatarPlaceholder' });
            if (this.state.avatarUrl) {
                showOverlayAnyways = false;
                avatarElement = _react2.default.createElement('img', { src: this.state.avatarUrl,
                    alt: (0, _languageHandler._t)("Room avatar") });
            }

            var avatarOverlayClasses = (0, _classnames2.default)({
                "mx_ProfileSettings_avatarOverlay": true,
                "mx_ProfileSettings_avatarOverlay_show": showOverlayAnyways
            });
            var avatarHoverElement = _react2.default.createElement(
                'div',
                { className: avatarOverlayClasses, onClick: this._uploadAvatar },
                _react2.default.createElement(
                    'span',
                    { className: 'mx_ProfileSettings_avatarOverlayText' },
                    (0, _languageHandler._t)("Upload room avatar")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_ProfileSettings_avatarOverlayImgContainer' },
                    _react2.default.createElement('div', { className: 'mx_ProfileSettings_avatarOverlayImg' })
                )
            );
            if (!this.state.canSetAvatar) {
                if (!showOverlayAnyways) {
                    avatarHoverElement = null;
                } else {
                    var disabledOverlayClasses = (0, _classnames2.default)({
                        "mx_ProfileSettings_avatarOverlay": true,
                        "mx_ProfileSettings_avatarOverlay_show": true,
                        "mx_ProfileSettings_avatarOverlay_disabled": true
                    });
                    avatarHoverElement = _react2.default.createElement(
                        'div',
                        { className: disabledOverlayClasses },
                        _react2.default.createElement(
                            'span',
                            { className: 'mx_ProfileSettings_noAvatarText' },
                            (0, _languageHandler._t)("No room avatar")
                        )
                    );
                }
            }

            return _react2.default.createElement(
                'form',
                { onSubmit: this._saveProfile, autoComplete: false, noValidate: true },
                _react2.default.createElement('input', { type: 'file', ref: 'avatarUpload', className: 'mx_ProfileSettings_avatarUpload',
                    onChange: this._onAvatarChanged, accept: 'image/*' }),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_ProfileSettings_profile' },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_ProfileSettings_controls' },
                        _react2.default.createElement(_Field2.default, { id: 'profileDisplayName', label: (0, _languageHandler._t)("Room Name"),
                            type: 'text', value: this.state.displayName, autoComplete: 'off',
                            onChange: this._onDisplayNameChanged, disabled: !this.state.canSetName }),
                        _react2.default.createElement(_Field2.default, { id: 'profileTopic', label: (0, _languageHandler._t)("Room Topic"), disabled: !this.state.canSetTopic,
                            type: 'text', value: this.state.topic, autoComplete: 'off',
                            onChange: this._onTopicChanged, element: 'textarea' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_ProfileSettings_avatar' },
                        avatarElement,
                        avatarHoverElement
                    )
                ),
                _react2.default.createElement(
                    _AccessibleButton2.default,
                    { onClick: this._saveProfile, kind: 'primary',
                        disabled: !this.state.enableProfileSave },
                    (0, _languageHandler._t)("Save")
                )
            );
        }
    }]);
    return RoomProfileSettings;
}(_react2.default.Component); /*
                              Copyright 2019 New Vector Ltd
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

RoomProfileSettings.propTypes = {
    roomId: _propTypes2.default.string.isRequired
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this._uploadAvatar = function (e) {
        e.stopPropagation();
        e.preventDefault();

        _this2.refs.avatarUpload.click();
    };

    this._saveProfile = function () {
        var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
            var client, newState, uri;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            e.stopPropagation();
                            e.preventDefault();

                            if (_this2.state.enableProfileSave) {
                                _context.next = 4;
                                break;
                            }

                            return _context.abrupt('return');

                        case 4:
                            _this2.setState({ enableProfileSave: false });

                            client = _MatrixClientPeg2.default.get();
                            newState = {};

                            // TODO: What do we do about errors?

                            if (!(_this2.state.originalDisplayName !== _this2.state.displayName)) {
                                _context.next = 11;
                                break;
                            }

                            _context.next = 10;
                            return (0, _bluebird.resolve)(client.setRoomName(_this2.props.roomId, _this2.state.displayName));

                        case 10:
                            newState.originalDisplayName = _this2.state.displayName;

                        case 11:
                            if (!_this2.state.avatarFile) {
                                _context.next = 20;
                                break;
                            }

                            _context.next = 14;
                            return (0, _bluebird.resolve)(client.uploadContent(_this2.state.avatarFile));

                        case 14:
                            uri = _context.sent;
                            _context.next = 17;
                            return (0, _bluebird.resolve)(client.sendStateEvent(_this2.props.roomId, 'm.room.avatar', { url: uri }, ''));

                        case 17:
                            newState.avatarUrl = client.mxcUrlToHttp(uri, 96, 96, 'crop', false);
                            newState.originalAvatarUrl = newState.avatarUrl;
                            newState.avatarFile = null;

                        case 20:
                            if (!(_this2.state.originalTopic !== _this2.state.topic)) {
                                _context.next = 24;
                                break;
                            }

                            _context.next = 23;
                            return (0, _bluebird.resolve)(client.setRoomTopic(_this2.props.roomId, _this2.state.topic));

                        case 23:
                            newState.originalTopic = _this2.state.topic;

                        case 24:

                            newState.enableProfileSave = true;
                            _this2.setState(newState);

                        case 26:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();

    this._onDisplayNameChanged = function (e) {
        _this2.setState({
            displayName: e.target.value,
            enableProfileSave: true
        });
    };

    this._onTopicChanged = function (e) {
        _this2.setState({
            topic: e.target.value,
            enableProfileSave: true
        });
    };

    this._onAvatarChanged = function (e) {
        if (!e.target.files || !e.target.files.length) {
            _this2.setState({
                avatarUrl: _this2.state.originalAvatarUrl,
                avatarFile: null,
                enableProfileSave: false
            });
            return;
        }

        var file = e.target.files[0];
        var reader = new FileReader();
        reader.onload = function (ev) {
            _this2.setState({
                avatarUrl: ev.target.result,
                avatarFile: file,
                enableProfileSave: true
            });
        };
        reader.readAsDataURL(file);
    };
};

exports.default = RoomProfileSettings;
module.exports = exports['default'];
//# sourceMappingURL=RoomProfileSettings.js.map